module.exports = __webpack_public_path__ + "static/media/ki.11ddea6b.jpeg";